import { useQuery } from '@tanstack/react-query';
import { CASE_SUBPROJECTS_KEY } from '../../utils/constants/queryKeys';
import { getCaseSubprojects } from '../services/fn-api/Cases';

export const useGetCaseSubprojects = (caseId: number) => {
  return useQuery({
    queryKey: [CASE_SUBPROJECTS_KEY, caseId],
    queryFn: () => getCaseSubprojects(caseId),
    enabled: !!caseId,
  });
};
